module.exports = __webpack_public_path__ + "img/SES_140250033.f21ce18d.jpg";